import {USER_CREATE_REQUEST, USER_CREATE_FAILURE, USER_CREATE_SUCCESS,
        RESEND_EMAIL_FAILURE, RESEND_EMAIL_REQUEST, RESEND_EMAIL_SUCCESS
} from './constants';

export function createUser (data) {
    return {
        type: USER_CREATE_REQUEST,
        data
    }
}

export function getUserCreateSuccessAction (data) {
    return {
        type: USER_CREATE_SUCCESS,
        data
    }
}

export function getUserCreateFailureAction (data) {
    return {
        type: USER_CREATE_FAILURE,
        data
    }
}

export function resendEmail (data) {
    return {
        type: RESEND_EMAIL_REQUEST,
        data
    }
}

export function resendEmailSuccess (data) {
    return {
        type: RESEND_EMAIL_SUCCESS,
        data
    }
}

export function resendEmailFailure () {
    return {
        type: RESEND_EMAIL_FAILURE,
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Register/actions.js